var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartitionLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 18",
    filter: "url(#filter0_d_1565_108575)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "#6929C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 19,
    stroke: "#491D8B",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "partition",
    d: "M25.125 13.75H27.375V12.5H25.125V13.75ZM16.5 13.75V14.375H17.75V13.75H18.375V12.5H17.75C17.0625 12.5 16.5 13.0625 16.5 13.75ZM30.25 26.25H29.625V27.5H30.25C30.9375 27.5 31.5 26.9375 31.5 26.25V25.625H30.25V26.25ZM17.75 25.625H16.5V26.25C16.5 26.9375 17.0625 27.5 17.75 27.5H18.375V26.25H17.75V25.625ZM30.25 12.5H29.625V13.75H30.25V14.375H31.5V13.75C31.5 13.0625 30.9375 12.5 30.25 12.5ZM20.625 13.75H22.875V12.5H20.625V13.75ZM30.25 23.375H31.5V21.125H30.25V23.375ZM17.75 16.625H16.5V18.875H17.75V16.625ZM25.125 27.5H27.375V26.25H25.125V27.5ZM30.25 18.875H31.5V16.625H30.25V18.875ZM20.625 27.5H22.875V26.25H20.625V27.5ZM17.75 21.125H16.5V23.375H17.75V21.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1565_108575",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_108575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_108575",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartitionLegend);
export default __webpack_public_path__ + "static/media/partitionLegend.0c32f8b8447ba832189e6c0ed8795205.svg";
export { ForwardRef as ReactComponent };